import { render, staticRenderFns } from "./StoreSignAndSet.vue?vue&type=template&id=5a6e805e&scoped=true&"
import script from "./StoreSignAndSet.vue?vue&type=script&lang=js&"
export * from "./StoreSignAndSet.vue?vue&type=script&lang=js&"
import style0 from "./StoreSignAndSet.vue?vue&type=style&index=0&id=5a6e805e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e805e",
  null
  
)

export default component.exports